import * as types from "../constants/ActionTypes";

const agents = (state = [], action) => {
  switch (action.type) {
    case types.ADD_AGENTS:
      return action.agents.map((agent) => {
        return agent;
      });
    case types.EDIT_SUPERINFO:
      return state.map((agent) => {
        if (agent.iduser === action.iduser) {
          return { ...agent, superinfo: true };
        }
        return agent;
      });
    case types.EDIT_AGENTS_JSON:
      return action.json;
    case types.EDIT_AGENTS:
      //let exist = false
      let newState = [...state];
      let exist =
        state.filter(
          (agent) => agent.iduser === action.id && agent.ramal === action.ramal,
        ).length !== 0
          ? true
          : false;
      if (exist === true) {
        return newState.map((agent) => {
          if (agent.iduser === action.id && agent.ramal === action.ramal) {
            return {
              ...agent,
              status_sip: action.status_sip,
              status: action.status,
              razao_bloqueio: action.razao_bloqueio,
              speaknum: action.speaknum,
              direcao: action.direcao,
              time: action.time,
              psdcount: action.psdcount,
              psdtma: action.psdtma,
              incallcount: action.incallcount,
              inanscount: action.inanscount,
              intmans: action.intmans,
              insla: action.insla,
              outcallcount: action.outcallcount,
              outanscount: action.outanscount,
              outtmans: action.outtmans,
              outsla: action.outsla,
              tmlogin: action.tmlogin,
              duration: action.duration,
              mediaid: action.mediaid,
              cdremcurso: action.cdremcurso,
              tmpausa:
                parseInt(action.psdtma) > 0
                  ? parseInt(action.psdtma) / parseInt(action.psdcount)
                  : 0,
              tmentrada:
                parseInt(action.intmans) > 0
                  ? parseInt(action.intmans) / parseInt(action.inanscount)
                  : 0,
              tmsaida:
                parseInt(action.outtmans) > 0
                  ? parseInt(action.outtmans) / parseInt(action.outanscount)
                  : 0,
              gdaagent:
                parseInt(action.tmlogin) > 0
                  ? 100 -
                    (parseInt(
                      parseInt(action.psdtma) +
                        parseInt(action.intmans) +
                        parseInt(action.outtmans),
                    ) /
                      parseInt(action.tmlogin)) *
                      100
                  : 0,
              dtl: action.dtl,
              visible: action.visible,
              superinfo: false,
              jsoncall: action.jsoncall,
              satisfaction: action.satisfaction,
              futurepause: action.futurepause,
              descfuturepause: action.descfuturepause,
              tmfuturepause: action.tmfuturepause,
              countfpause: action.countfpause,
              directionChnd: action.directionChnd,
            };
          }
          return agent;
        });
      } else {
        return [
          ...state,
          {
            iduser: action.id,
            status_sip: action.status_sip,
            status: action.status,
            razao_bloqueio: action.razao_bloqueio,
            speaknum: action.speaknum,
            direcao: action.direcao,
            time: action.time,
            psdcount: action.psdcount,
            psdtma: action.psdtma,
            incallcount: action.incallcount,
            inanscount: action.inanscount,
            intmans: action.intmans,
            insla: action.insla,
            outcallcount: action.outcallcount,
            outanscount: action.outanscount,
            outtmans: action.outtmans,
            outsla: action.outsla,
            tmlogin: action.tmlogin,
            duration: action.duration,
            mediaid: action.mediaid,
            desc_grupo: action.desc_grupo,
            id_grupo: action.id_grupo,
            label: action.label,
            ramal: action.ramal,
            usedmodule: action.usedmodule,
            username: action.username,
            value: action.id,
            cdremcurso: action.cdremcurso,
            tmpausa:
              parseInt(action.psdtma) > 0
                ? parseInt(action.psdtma) / parseInt(action.psdcount)
                : 0,
            tmentrada:
              parseInt(action.intmans) > 0
                ? parseInt(action.intmans) / parseInt(action.inanscount)
                : 0,
            tmsaida:
              parseInt(action.outtmans) > 0
                ? parseInt(action.outtmans) / parseInt(action.outanscount)
                : 0,
            gdaagent:
              parseInt(action.tmlogin) > 0
                ? 100 -
                  (parseInt(
                    parseInt(action.psdtma) +
                      parseInt(action.intmans) +
                      parseInt(action.outtmans),
                  ) /
                    parseInt(action.tmlogin)) *
                    100
                : 0,
            dtl: action.dtl,
            satisfaction: action.satisfaction,
            futurepause: action.futurepause,
            descfuturepause: action.descfuturepause,
            tmfuturepause: action.tmfuturepause,
            directionChnd: action.directionChnd,
          },
        ];
      }

    default:
      return state;
  }
};

export default agents;
